import {$gettext} from './lib/gettext';

jQuery(function ($) {
    $(document).on('click', 'a.mvv-load-in-new-row', function () {
        STUDIP.MVV.Content.loadRow($(this));
        return false;
    });

    $(document).on('click', '.loaded-details a.cancel', function () {
        $(this).closest('.loaded-details').prev().find('toggler').click();
        return false;
    });

    STUDIP.MVV.Sort.init($('.sortable'));

    $(document).on('change', '#mvv-chooser select', function(){
        STUDIP.MVV.Chooser.create($(this));
        return false;
    });

    $(document).on('click', '.mvv-item-remove', function () {
        STUDIP.MVV.Content.removeItem(this);
        return false;
    });

    $(document).on('click', '.mvv-item-edit', function () {
        STUDIP.MVV.Content.editAnnotation(this);
        return false;
    });

    $(document).on('click', '.mvv-item-edit-properties', function () {
        $(this).parents("li").find(".mvv-item-document-comments").toggle();
        return false;
    });

    // get the quicksearch input
    $(document).on('click focus', '.ui-autocomplete-input', function() {
        STUDIP.MVV.Search.qs_input = this;
        return false;
    });

    $('.with-datepicker').datepicker();

    $(document).on('change', '.mvv-inst-chooser select', function() {
        STUDIP.MVV.LanguageChooser.showButtons($(this));
        return false;
    });

    $(document).on('click', '.mvv-show-original', function() {
        STUDIP.MVV.Content.showOriginal($(this));
        return false;
    });

    $(document).on('click', '.mvv-show-all-original', function() {
        STUDIP.MVV.Content.showAllOriginal();
        return false;
    });

    $(document).on('click', 'a.mvv-new-tab', function () {
        STUDIP.MVV.Diff.openNewTab(this);
        return false;
    });

    $(document).on('click', 'input.mvv-qs-button', function () {
        STUDIP.MVV.Search.addSelect($(this));
        return false;
    });

    $(document).on('click', '.stgfile .remove_attachment', function () {
        STUDIP.Dialog.confirm($gettext('Soll die Datei wirklich gelöscht werden?')).done(() => {
            STUDIP.MVV.Document.remove_attachment(this);
        });
        return false;
    });

    $(document).on('click', '.stgfile .refresh_attachment', (event) => {
        STUDIP.MVV.Document.refresh_attachment(event.target);
        event.preventDefault();
    });

    STUDIP.dialogReady(
        function() {

            const contactSearchParams = $('#search-contact-params');
            const contactSearchSelect = $('#search-contact-select');
            if (contactSearchParams) {
                contactSearchSelect.select2({
                    placeholder: contactSearchSelect.data('placeholder'),
                    minimumInputLength: 3,
                    ajax: {
                        url: STUDIP.URLHelper.getURL('dispatch.php/shared/contacts/search_'
                                + contactSearchSelect.data('search_type')),
                        data(params) {
                            return {
                                term: params.term,
                                _type: params._type,
                                contact_id: contactSearchParams.data('contact')
                            };
                        },
                        dataType: 'json'
                    }
                });
            }

            $('#search-file-select').select2({
                placeholder: $gettext('Dokument suchen'),
                minimumInputLength: 3,
                ajax: {
                    url: STUDIP.URLHelper.getURL('dispatch.php/materialien/files/search_file'),
                    dataType: 'json'
                }
            });

            $('#search-file-studiengang-select').select2({
                placeholder: $gettext('Studiengang suchen'),
                minimumInputLength: 3,
                ajax: {
                    url: STUDIP.URLHelper.getURL('dispatch.php/materialien/files/search_studiengang'),
                    dataType: 'json'
                }
            });
            $('#search-file-modul-select').select2({
                placeholder: $gettext('Modul suchen'),
                minimumInputLength: 3,
                ajax: {
                    url: STUDIP.URLHelper.getURL('dispatch.php/materialien/files/search_modul'),
                    dataType: 'json'
                }
            });
            $('#search-file-abschlusskategorie-select').select2({
                placeholder: $gettext('AbschlussKategorie suchen'),
                minimumInputLength: 3,
                ajax: {
                    url: STUDIP.URLHelper.getURL('dispatch.php/materialien/files/search_abschlusskategorie'),
                    dataType: 'json'
                }
            });
        }
    );

});

/* ------------------------------------------------------------------------
 * the local MVV namespace
 * ------------------------------------------------------------------------ */
window.STUDIP.MVV = window.STUDIP.MVV || {};

STUDIP.MVV.Search = {
    qs_input : null,
    qs_selected_name : null,
    getFocus(item_id) {
        const qs_input = jQuery(STUDIP.MVV.Search.qs_input);
        const qs_item = jQuery('#' + qs_input.attr('id'));
        if (item_id === '') {
            STUDIP.MVV.Search.addSelect(qs_item);
        } else {
            qs_input.closest('form')
                .find('.mvv-submit')
                .show()
                .focus();
        }
        return true;
    },
    addButton(item_id) {
        const qs_input = jQuery(STUDIP.MVV.Search.qs_input);
        const qs_item = jQuery('#' + qs_input.attr('id'));
        if (item_id === '') {
            STUDIP.MVV.Search.addSelect(qs_item);
        } else {
            STUDIP.MVV.Search.addTheButton(qs_item);
        }
        return true;
    },

    addTheButton(qs_item) {
        const add_button = jQuery('<a href="#" />').addClass('mvv-add-item');
        const qs_name = qs_item.attr('id');
        const target_name = qs_name.slice(0, qs_name.lastIndexOf('_'));
        const item_id = jQuery('#' + qs_name + '_realvalue').val();
        jQuery('<button>')
            .addClass('btn-icon btn-icon--add')
            .attr('aria-label', $gettext('hinzufügen'))
            .appendTo(add_button);
        if (item_id === '') {
            qs_item.siblings('.mvv-add-button').find('.mvv-add-item')
                .fadeOut('slow', function () {
                    qs_item.val('').focus();
                    jQuery(this).remove();
                });
        } else {
            add_button.click(function () {
                    if (_.isNull(STUDIP.MVV.Search.qs_selected_name)) {
                        STUDIP.MVV.Content.addItem(target_name, item_id,
                            qs_item.val());
                    } else {
                        STUDIP.MVV.Content.addItem(target_name, item_id,
                            STUDIP.MVV.Search.qs_selected_name);
                    }
                    jQuery(this).fadeOut('slow', function () {
                        qs_item.val('').focus();
                        jQuery(this).remove();
                    });
                    jQuery('#select_' + qs_name).fadeOut('fast', function () {
                        jQuery(this).next('.mvv-search-reset').fadeOut();
                        jQuery('#' + qs_name).fadeIn();
                        jQuery(this).remove();
                    });
                    return false;
                }
            );
            qs_item.siblings('.mvv-add-button').first().children('.mvv-add-item')
                .fadeOut('slow').remove();
            qs_item.siblings('.mvv-add-button').first().append(add_button);
            add_button.fadeIn('slow');
            qs_item.siblings('.mvv-select-group').fadeIn();
            add_button.focus();
            qs_item.focus(function () {
                add_button.fadeOut();
                qs_item.siblings('.mvv-select-group').fadeOut();
            });
        }
        return true;
    },

    addSelect: function (qs_item) {
        var qs_input = jQuery('#' + qs_item.data('qs_name')),
            qs_real = qs_input.prev('input'),
            qs_name = qs_input.attr('id'),
            qs_select = jQuery('<select/>').attr('id', 'select_' + qs_name)
                .addClass('mvv-search-select-list')
                .css({display: 'inline'}),
            qs_id = qs_item.data('qs_id'),
            do_submit = qs_item.data('qs_submit');
        var reset_button = jQuery('<input type="image" />');
            reset_button.attr({
                src: STUDIP.ASSETS_URL+'images/icons/blue/decline.svg',
                title: $gettext("Suche zurücksetzen")
            }).addClass('mvv-search-reset middle')
                .css({display: 'inline'});
        if (!_.isUndefined(do_submit)) {
            qs_select.change(function() {
                var selected = qs_select.children('option:selected');
                qs_real.val(selected.val());
                if (do_submit === 'yes') {
                    qs_input.closest('form').submit();
                }
            });
        } else {
            qs_select.change(function() {
                var selected = qs_select.children('option:selected');
                STUDIP.MVV.Search.addSelected.call(
                    qs_real,
                    selected.val(),
                    selected.text().trim()
                );
            });
        }
        jQuery.ajax({
            url: STUDIP.URLHelper.getURL(STUDIP.MVV.CONTROLLER_URL + 'qs_result'),
            data: {'qs_id': qs_id, 'qs_term': qs_input.val()},
            type: 'POST',
            success: function (data) {
                for (var i in data) {
                    var d = data[i];
                    jQuery('<option/>').attr('value', d.id).text(d.name)
                        .appendTo(qs_select);
                }
                qs_input.fadeOut('fast', function () {
                    var inp = jQuery(this);
                    reset_button.click(function () {
                        qs_select.fadeOut('fast', function () {
                            reset_button.hide();
                            qs_select.remove();
                            inp.val('');
                            inp.fadeIn().focus();
                            qs_item.fadeIn();
                        });
                        reset_button.remove();
                    });
                    qs_select.insertAfter(qs_input);
                    qs_item.fadeOut('fast', function () {
                        reset_button.insertAfter(this).fadeIn();
                    });
                    qs_select.fadeIn().focus();
                });
            }
        });
    },

    submitSelected() {
        jQuery(this).closest('form').submit();
    },

    addSelected(item_id, item_name) {
        const strip_tags = /<\w+(\s+("[^"]*"|'[^']*'|[^>])+)?>|<\/\w+>/gi;
        const qs_name = $(this).attr('name');
        //QUICKSEARCHTODO
        //target_name = qs_id.slice(0, qs_id.lastIndexOf('_'));
        const target_name = qs_name.split('_')[0];
        STUDIP.MVV.Content.addItem(
            target_name,
            item_id,
            jQuery('<div/>').html(item_name.replace(strip_tags, '')).text()
        );
    },

    insertFachName(item_id) {
        $.get(STUDIP.URLHelper.getURL(STUDIP.MVV.CONTROLLER_URL + 'fach_data'), {
            fach_id: item_id
        }).done(d => {
            if (_.isNull(d.name)) {
                $('input[name="name"]').attr(
                    'placeholder',
                    $gettext('Keine Angabe beim Fach')
                );
            } else {
                $('input[name="name"]').attr({
                    value: d.name,
                    placeholder: d.name,
                    'aria-label': d.name,
                });
            }
            if (_.isNull(d.name_en)) {
                $('input[name="name_i18n[en_GB]"]').attr(
                    'placeholder',
                    $gettext('Keine Angabe beim Fach')
                );
            } else {
                $('input[name="name_i18n[en_GB]"]').attr('value', d.name_en);
            }
            if (_.isNull(d.name_kurz)) {
                $('input[name="name_kurz"]').attr(
                    'placeholder',
                    $gettext('Keine Angabe beim Fach')
                );
            } else {
                $('input[name="name_kurz"]').attr('value', d.name_kurz);
            }
            if (_.isNull(d.name_kurz_en)) {
                $('input[name="name_kurz_i18n[en_GB]"]').attr(
                    'placeholder',
                    $gettext('Keine Angabe beim Fach')
                );
            } else {
                $('input[name="name_kurz_i18n[en_GB]"]').attr('value', d.name_kurz_en);
            }
        });
    }
};

STUDIP.MVV.Sort = {
    i: null,
    start(event, ui) {
        STUDIP.MVV.Sort.i = jQuery(ui.item).index();
    },
    stop(event, ui) {
        var i = jQuery(ui.item).index();
        if (STUDIP.MVV.Sort.i !== i) {
            var newOrder = jQuery(this).sortable('toArray');
            var tableID = jQuery(this).closest('.sortable').attr('id');
            STUDIP.MVV.Sort.save(newOrder, tableID);
        }
    },
    save(newOrder, tableID) {
        jQuery.ajax({
            url: STUDIP.URLHelper.getURL(STUDIP.MVV.CONTROLLER_URL + 'sort'),
            data: {
                'list_id': tableID,
                'newOrder': newOrder
            },
            type: 'POST',
            success: function () {
            }
        });
    },
    init(target) {
        target.sortable({
            items: '> .sort_items',
            cursor: 'move',
            containment: 'parent',
            tolerance: 'pointer',
            axis: 'y',
            start: STUDIP.MVV.Sort.start,
            stop: STUDIP.MVV.Sort.stop
        });
    }
};

STUDIP.MVV.Chooser = {
    create(element) {
        var parent = element.closest('form');
        jQuery('#mvv-load-content').fadeOut().html('');
        jQuery.ajax({
            url: STUDIP.URLHelper.getURL(parent.attr('action')),
            data: parent.serializeArray(),
            type: 'POST',
            success(data) {
                const next = parent.nextAll();
                if (jQuery(data).is('form')) {
                    if (next.length !== 0) {
                        jQuery('.mvv-version-content').nextAll().fadeOut().remove();
                        jQuery('.mvv-version-content').fadeIn();
                        next.remove();
                    }
                    parent.after(data);
                } else {
                    location.reload();
                }
            }
        });
    }
};

STUDIP.MVV.LanguageChooser = {
    showButtons(element) {
        const chooser = element.closest('.mvv-inst-chooser');
        const sel = chooser.find(':selected');
        chooser.find('.mvv-inst-add-button svg').fadeOut();
        if (!sel.hasClass('mvv-inst-chooser-level')) {
            const button = chooser.find('.mvv-inst-add-button svg');
            button.fadeIn('fast').unbind('click');
            jQuery(button).click(function () {
                if (sel.data('fb') === '') {
                    STUDIP.MVV.Content.addItem(
                        chooser.find('select').attr('name'),
                        sel.val(), sel.text());
                } else {
                    STUDIP.MVV.Content.addItem(
                        chooser.find('select').attr('name'),
                        sel.val(),
                        sel.data('fb') + ' - ' + sel.text());
                }
            });
        }
    }
};

STUDIP.MVV.Content = {
    deskriptor_data: null,

    get(id) {
        jQuery('#mvv-load-content').load(
            STUDIP.URLHelper.getURL(STUDIP.MVV.CONTROLLER_URL + 'content/' + id), function () {
                jQuery('#mvv-load-content').fadeIn();
            });
    },
    addItem(target_name, item_id, item_name) {
        let target = jQuery('#' + target_name + '_target');
        let group_id = '';
        let li_id = item_id;
        if (target.hasClass('mvv-assign-group')) {
            group_id = target.siblings('.mvv-select-group').find(':selected').val();
            li_id = target_name + '_' + group_id + '_' + li_id;
        } else {
            li_id = target_name + '_' + li_id;
        }
        if (jQuery('#' + li_id).length) {
            jQuery('#' + li_id)
                .effect('highlight', {color: '#ff0000'}, 1500);
        } else {
            var item = jQuery('<li/>').attr('id', li_id);
            jQuery('<div class="mvv-item-list-text"/>')
                .text(item_name).appendTo(item);
            if (target.hasClass('sortable')) {
                item.addClass('drag-handle sort_items');
            }
            target.children('.mvv-item-list-placeholder').hide();
            if (target.hasClass('mvv-assign-single')) {
                target.children().not('.mvv-item-list-placeholder').remove();
                jQuery('<input type="hidden" />')
                    .attr('name', target_name + '_item')
                    .val(item_id).appendTo(item);
            } else {
                if (target.hasClass('mvv-assign-group')) {
                    jQuery('<input type="hidden" />')
                        .attr('name', target_name + '_items_' + group_id + '[]')
                        .val(item_id).appendTo(item);
                } else {
                    jQuery('<input type="hidden" />')
                        .attr('name', target_name + '_items[]')
                        .val(item_id).appendTo(item);
                }
            }
            const button_list = jQuery('<div ' + 'class="mvv-item-list-buttons"/>')
                .append('<a href="#" class="mvv-item-remove"><img width="20" height="20" alt="Trash" src="'
                    + STUDIP.ASSETS_URL
                    + 'images/icons/blue/trash.svg"></a>');
            button_list.appendTo(item);
            if (target.is('.mvv-with-annotations')) {
                const text_area = jQuery('<textarea/>').attr('name',
                    target_name + '_' + 'annotations[' + item_id + ']');
                jQuery('<div/>').append(text_area).appendTo(item);
            }
            if (target.hasClass('mvv-with-properties')) {
                const prop_input = jQuery('<div/>').addClass('mvv-item-list-properties');
                jQuery('<img src="' + STUDIP.ASSETS_URL + 'images/languages/lang_de.gif"/>')
                    .appendTo(prop_input);
                jQuery('<textarea name="kommentar[' + item_id + ']"/>').appendTo(prop_input);
                jQuery('<img src="' + STUDIP.ASSETS_URL + 'images/languages/lang_en.gif"/>')
                    .appendTo(prop_input);
                jQuery('<textarea name="kommentar_en[' + item_id + ']"/>').appendTo(prop_input);
                prop_input.appendTo(item);
            }
            if (target.hasClass('mvv-assign-group')) {
                target = target.find('#' + target_name + '_' + group_id);
                target.append(item);
                target.parent().fadeIn('fast', function () {
                    item.effect('highlight', {color: '#55ff55'}, 1500);
                });
            } else {
                target.append(item);
                item.effect('highlight', {color: '#55ff55'}, 1500);
            }
        }
    },

    addItemFromDialog(data) {
        STUDIP.MVV.Content.addItem(data.target, data.item_id, data.item_name);
    },

    removeItem(this_button) {
        var item = jQuery(this_button).closest('li');
        if (item.closest('.mvv-assigned-items').hasClass('mvv-assign-group')) {
            if (item.siblings().length == 0) {
                item.parent().parent('li').fadeOut();
            }
            if (item.parent().parent().siblings(':visible').length == 0) {
                item.parent().parent()
                    .siblings('.mvv-item-list-placeholder').fadeIn('slow');
            }
        } else {
            if (item.siblings().length < 2) {
                item.siblings('.mvv-item-list-placeholder').fadeIn('slow');
            }
        }
        item.remove();
    },
    editAnnotation(button) {
        var this_button = jQuery(button),
            item = this_button.closest('li'),
            target_id = item.attr('id'),
            target_name = target_id.slice(0, target_id.lastIndexOf('_')),
            item_id = target_id.slice(target_id.lastIndexOf('_') + 1, target_id.length),
            annotation = item.children('.mvv-item-list-properties').first(),
            content = annotation.children('div').first();
        content.hide('slow', function () {
            jQuery('<textarea/>').attr('name', target_name + '_annotations['
                + item_id + ']').text(content.text()).hide().appendTo(annotation)
                .fadeIn();
            this_button.fadeOut();
        });
    },
    editProperties(button) {
        var this_button = jQuery(button),
            item = this_button.closest('li');
        STUDIP.MVV.EditForm.openRef(item);
    },
    loadRow(element) {
        if (element.data('busy')) {
            return false;
        }
        if (element.closest('tr').next().hasClass('loaded-details')) {
            element.closest('tbody').toggleClass('collapsed not-collapsed');
            return false;
        }
        element.data('busy', true);
        jQuery.get(element.attr('href'), '', function (response) {
            var row = jQuery('<tr />').addClass('loaded-details nohover');
            element.closest('tbody').append(row);
            element.closest('tbody').children('.loaded-details').html(response);
            element.data('busy', false);
            jQuery('body').trigger('ajaxLoaded');
            jQuery(row).show();
            STUDIP.MVV.Sort.init(jQuery('.sortable'));
            row.find('.sortable-table').each((index, element) => {
                STUDIP.Table.enhanceSortableTable(element);
            });
        });
        element.closest('tbody').toggleClass('collapsed not-collapsed');
        return false;
    },
    showOriginal(element) {
        if (element.data('hasData')) {
            element.next().slideToggle('fast');
            return false;
        }
        if (_.isNull(STUDIP.MVV.Content.deskriptor_data)) {
            jQuery.ajax({
                url: STUDIP.URLHelper.getURL(STUDIP.MVV.CONTROLLER_URL + 'show_original/'),
                data: {
                    'id': STUDIP.MVV.PARENT_ID,
                    'type': element.data('type')
                },
                type: 'POST',
                async: false,
                success: function (data) {
                    if (data.length !== 0) {
                        STUDIP.MVV.Content.deskriptor_data = data;
                    }
                }
            });
        }
        if (!_.isNull(STUDIP.MVV.Content.deskriptor_data)) {
            const field_id = element.closest('label')
                .find('textarea, input[type=text]')
                .attr('id');
            const item = jQuery('<div/>').addClass('mvv-orig-lang');
            if (!_.isUndefined(STUDIP.MVV.Content.deskriptor_data[field_id])) {
                if (STUDIP.MVV.Content.deskriptor_data[field_id]['empty']) {
                    item.css({
                        "color": "red",
                        "font-style": "italic"
                    });
                }
                item.html(STUDIP.MVV.Content.deskriptor_data[field_id]['value']);
            } else {
                item.html($gettext("Datenfeld in Original-Sprache nicht verfügbar."));
                item.css({
                    "color": "red",
                    "font-style": "italic"
                });
            }
            item.insertAfter(element);
            item.slideDown('fast');
            element.data('hasData', true);
        }
        return false;
    },
    showAllOriginal() {
        jQuery('.mvv-show-original').each(function () {
            if ($(this).next(':visible').length === 0) {
                $(this).click();
            }
        });
        return false;
    }
};

STUDIP.MVV.Diff = {
    "openNewTab": function (item) {
        let url_to_open = null;
        let new_id = null;
        let old_id = null;
        const source = jQuery(item);
        if (source.is('a')) {
            url_to_open = item.href;
            window.open(STUDIP.URLHelper.getURL(url_to_open));
        } else {
            url_to_open = source.closest('form').attr('action');
            new_id = source.siblings('[name="new_id"]').attr('value');
            old_id = source.siblings('[name="old_id"]').attr('value');
            window.open(STUDIP.URLHelper.getURL(url_to_open,
                {'new_id': new_id, 'old_id': old_id}));
        }
        return false;
    }
};

STUDIP.MVV.Document = {
    reload_documenttable(range_id, range_type) {
        setTimeout(() => {
            jQuery.ajax({
                url: STUDIP.ABSOLUTE_URI_STUDIP + 'dispatch.php/materialien/files/' + (typeof range_id != 'undefined' ? 'range' : 'index'),
                data: {
                    'range_id': range_id,
                    'range_type': range_type
                },
                type: 'POST',
                success(data) {
                    jQuery(data).each(function () {
                        jQuery('#' + jQuery(this).attr("id")).html(jQuery(this).html());
                    });
                }
            })
        }, 100);
    },
    refresh_attachment(item) {
        const language = item.closest('button').dataset.language;
        const document_id = item.closest('.stgfile').querySelector('[name="document_id"]').value;

        const input = document.createElement('input');
        input.type = 'file';
        input.hidden = true;

        input.addEventListener('cancel', () => {
            input.remove();
        });
        input.addEventListener('change', () => {
            const fd = new FormData();
            fd.append('file', input.files[0], input.files[0].name);
            fd.append('mvvfile_id', jQuery('#mvvfile_id').val());
            fd.append('range_id', jQuery('#range_id').val());
            fd.append('document_id', document_id);
            fd.append('file_language', language);

            const statusbar = $('#statusbar_container .statusbar')
                .first()
                .clone()
                .show();
            statusbar.appendTo('#statusbar_container');

            STUDIP.MVV.Document.upload_file(fd, statusbar, true).then(() => {
                input.remove();
            });
        });

        item.parentNode.after(input);
        input.click();
    },
    remove_attachment(item) {
        const url = STUDIP.URLHelper.getURL('dispatch.php/materialien/files/delete_attachment', {
            mvvfile_id: document.getElementById('mvvfile_id').value,
            fileref_id: item.closest('li').querySelector('input[name=document_id]').value,
        });
        $.post(url).done(() => {
            $(item).closest('td').find('.attachments').toggle();
            $(item).closest('li').fadeOut(300, function () {
                this.remove();
                jQuery('#upload_chooser').show();
            });
        });
    },
    upload_from_input(input, file_language) {
        STUDIP.MVV.Document.upload_files(input.files, file_language);
        input.value = '';
    },
    fileIDQueue: 1,
    upload_files(files, file_language) {
        for (let i = 0; i < files.length; i++) {
            const fd = new FormData();
            fd.append('file', files[i], files[i].name);
            const statusbar = jQuery('#statusbar_container .statusbar')
                .first()
                .clone()
                .show();
            statusbar.appendTo('#statusbar_container');
            fd.append('mvvfile_id', jQuery('#mvvfile_id').val());
            fd.append('range_id', jQuery('#range_id').val());
            fd.append('file_language', file_language);
            STUDIP.MVV.Document.upload_file(fd, statusbar);
        }
    },
    upload_file(formdata, statusbar, update = false) {
        return new Promise((resolve, reject) => {
            $.ajax({
                xhr() {
                    var xhrobj = $.ajaxSettings.xhr();
                    if (xhrobj.upload) {
                        xhrobj.upload.addEventListener(
                            'progress',
                            function(event) {
                                var percent = 0;
                                var position = event.loaded || event.position;
                                var total = event.total;
                                if (event.lengthComputable) {
                                    percent = Math.ceil((position / total) * 100);
                                }
                                //Set progress
                                statusbar.find('.progress').css({ 'min-width': percent + '%', 'max-width': percent + '%' });
                                statusbar
                                    .find('.progresstext')
                                    .text(percent === 100 ? jQuery('#upload_finished').text() : percent + '%');
                            },
                            false
                        );
                    }
                    return xhrobj;
                },
                url: STUDIP.ABSOLUTE_URI_STUDIP + 'dispatch.php/materialien/files/upload_attachment',
                type: 'POST',
                contentType: false,
                processData: false,
                cache: false,
                data: formdata,
                dataType: 'json'
            }).done((data) => {
                const language = formdata.get('file_language');

                statusbar.find('.progress').css({ 'min-width': '100%', 'max-width': '100%' });
                var file = jQuery('#fileselector_'+formdata.get('file_language')).find('.stgfiles > .stgfile')
                    .first()
                    .clone();
                file.find('.name').text(data.name);
                if (data.size < 1024) {
                    file.find('.size').text(data.size + 'B');
                }
                if (data.size > 1024 && data.size < 1024 * 1024) {
                    file.find('.size').text(Math.floor(data.size / 1024) + 'KB');
                }
                if (data.size > 1024 * 1024 && data.size < 1024 * 1024 * 1024) {
                    file.find('.size').text(Math.floor(data.size / 1024 / 1024) + 'MB');
                }
                if (data.size > 1024 * 1024 * 1024) {
                    file.find('.size').text(Math.floor(data.size / 1024 / 1024 / 1024) + 'GB');
                }
                file.find('.icon').html(data.icon);
                file.find('input[name=document_id]').attr('value', data.document_id);
                if (update) {
                    $(`#fileviewer_${language} .stgfiles`).empty().append(file);
                    file.show();
                } else {
                    $(`#fileviewer_${language}`).find('.stgfiles').append(file);
                    $(`#fileselector_${language}`)
                        .toggle()
                        .parents('.attachments').toggle()
                        .find('span').toggle();
                    file.fadeIn(300);
                }
                statusbar.find('.progresstext').text(jQuery('#upload_received_data').text());
                statusbar.delay(1000).fadeOut(300, function() {
                    $('#upload_chooser').hide();
                    this.remove();
                });

                resolve();
            }).fail(function(jqxhr) {
                const error = jqxhr.responseJSON.error;

                statusbar
                    .find('.progress')
                    .addClass('progress-error')
                    .attr('title', error);
                statusbar.find('.progresstext').html(error);
                statusbar.on('click', function() {
                    jQuery(this).fadeOut(300, function() {
                        jQuery(this).remove();
                    });
                });

                reject(new Error(error));
            });
        });
    }
};


STUDIP.MVV.Contact = {
    reload_contacttable(range_id, range_type) {
        setTimeout(() => {
            jQuery.ajax({
                url: STUDIP.ABSOLUTE_URI_STUDIP + 'dispatch.php/shared/contacts/' + (typeof range_id != 'undefined' ? 'range' : 'index'),
                data: {
                    'range_id': range_id,
                    'range_type': range_type
                },
                type: 'POST',
                success(data) {
                    jQuery(data).each(function () {
                        jQuery('#' + jQuery(this).attr("id")).html(jQuery(this).html());
                    });
                }
            })
        }, 100);
    }
};

STUDIP.MVV.Aufbaustg = {
    create(df) {
        setTimeout(() => {
            $.ajax({
                url: STUDIP.URLHelper.getURL('dispatch.php/studiengaenge/studiengaenge/aufbaustg_store'),
                data: $(df).serialize(),
                type: 'POST',
                success(data) {
                    $('#mvv-aufbaustg-table').html($(data).html()).find('.sortable-table').each((index, element) => {
                        STUDIP.Table.enhanceSortableTable(element);
                    });
                }
            })
        }, 100);
    },
    loadTable(stg_id) {
        setTimeout(() => {
            $.ajax({
                url: STUDIP.URLHelper.getURL('dispatch.php/studiengaenge/studiengaenge/aufbaustg_table/' + stg_id),
                type: 'GET',
                success(data) {
                    $('#mvv-aufbaustg-table').html($(data).html()).find('.sortable-table').each((index, element) => {
                        STUDIP.Table.enhanceSortableTable(element);
                    });
                }
            })
        }, 100);
    }
}
